import { FC, useMemo, type JSX } from 'react';
import { useRegion } from '@/api/rest/users/useRegion';

import BasicField from '@payaca/components/basicField/BasicField';
import FormattedNumberField, {
  NumberFormatVariant,
} from '@payaca/components/formattedNumberField/FormattedNumberField';
import { InputStyleVariant } from '@payaca/components/inputWrapper/InputWrapper';

import { AccountRegions } from '@payaca/types/accountTypes';

type Props = {
  isReadOnly?: boolean;
  name: string;
  onChange: (value: { [key: string]: any }) => void;
  value: string;
};
const AccountNumberField: FC<Props> = ({
  isReadOnly = false,
  name,
  onChange,
  value,
}: Props): JSX.Element => {
  const region = useRegion();

  /* oxlint-disable react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useMemo has a missing dependency: 'name' */
  const accountNumberField = useMemo(() => {
    switch (region) {
      case AccountRegions.AUSTRALIA:
        return (
          <FormattedNumberField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            formatVariant={NumberFormatVariant.AU_ACCOUNT_NUMBER}
            isDisabled={isReadOnly}
          />
        );
      case AccountRegions.CANADA:
        return (
          <BasicField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            isDisabled={isReadOnly}
          />
        );
      case AccountRegions.NEW_ZEALAND:
        return (
          <FormattedNumberField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            formatVariant={NumberFormatVariant.NZ_ACCOUNT_NUMBER}
            isDisabled={isReadOnly}
          />
        );
      case AccountRegions.SOUTH_AFRICA:
        return (
          <BasicField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            isDisabled={isReadOnly}
          />
        );
      case AccountRegions.UK:
        return (
          <FormattedNumberField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            formatVariant={NumberFormatVariant.ACCOUNT_NUMBER}
            isDisabled={isReadOnly}
          />
        );
      case AccountRegions.US:
        return (
          <BasicField
            name={name}
            label="Account number"
            value={value}
            styleVariant={InputStyleVariant.OUTSIZE}
            onChange={onChange}
            isDisabled={isReadOnly}
          />
        );
      default:
        return <></>;
    }
  }, [onChange, value, region, isReadOnly]);
  /* oxlint-enable eslint-plugin-react-hooks(exhaustive-deps) */

  return accountNumberField;
};

export default AccountNumberField;
